import { useContext } from 'react';

import { PDPStateContext, PDPDispatchContext } from 'productTemplate/providers/PDPStateProvider';

export const usePDPState = () => useContext(PDPStateContext);
export const usePDPDispatch = () => useContext(PDPDispatchContext);
